import React, { useEffect } from 'react'
import useMobile from '../../../hooks/useMobile';
import { GatsbyImage } from 'gatsby-plugin-image'
import banderaBolivia from '../../../assets/images/bandera-bolivia.png'
import banderaRepublicaDominicana from '../../../assets/images/bandera-republica-dominicana.png'
import './modal-change-country.scss'


//-------DELETE WHEN CMS--------

const ModalChangeCountry = ({ countries, setModalChange }) => {

    const mobile = useMobile();

    const closeModal = () => {
        let element = document.getElementById('f-m-change-country__content')
        if (element) {
            element.classList.add("f-m-change-country__content-hidden")
            setTimeout(function () {
                element.classList.remove("f-m-change-country__content-hidden")
                if (mobile) {
                    document.documentElement.style.overflow = 'scroll';
                    document.body.scroll = "yes";
                }
                setModalChange(false);
            }, 200);
        } else {
            setModalChange(false);
        }
    }

    useEffect(() => {
        let lastScrollTop = window.pageYOffset;
        window.addEventListener('scroll', function (ev) {
            // mobile
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop < lastScrollTop) {
                closeModal()
            }
            lastScrollTop = scrollTop;

        });

    }, [])

    return (
        <div className="f-m-change-country">
            <div className="f-m-change-country__content-modal-close" onClick={closeModal}></div>
            <div className="f-m-change-country__content" id="f-m-change-country__content">
                <span className="icon icon-ico-x f-m-change-country__close" onClick={closeModal}></span>
                <p className="f-m-change-country__content-title">Selecciona el país</p>
                <div className="f-m-change-country__content-countries">
                    {countries && countries.map((country, index) => {
                        return (
                            <a className="f-m-change-country__content-countries-country" key={index} href={country.paises[0].dominioDelPais}>
                                {country.paises[0].banderaPais.gatsbyImageData ?
                                    <GatsbyImage className="f-m-footer__country-flag" image={country.paises[0].banderaPais.gatsbyImageData} alt={country.paises[0].banderaPais.description} />
                                    :
                                    country.paises[0].banderaPais.file &&
                                    <img className="f-m-footer__country-flag" src={country.paises[0].banderaPais.file.url} alt={country.paises[0].banderaPais.description} />
                                }
                                <p className="f-m-footer__country-text f-m-footer__country-text-country">{country.paises[0].pais}</p>
                            </a>
                        )
                    })
                    }
                </div>
            </div>
        </div>
    )
}

export default ModalChangeCountry
